import { get, isEmpty } from 'lodash';
import { MISSION_STATUS } from 'containers/data-structure';
import { COLORS } from 'constants/design';
import { MISSION_NATURE } from 'containers/ExpertExpertise/ConcernedExpertise/constants';
export const isRejectedMission = (mission: any) => {
  const filtredExpertStatus = get(
    mission,
    'assignedExpert',
    [],
  ).map((element: any) => (element.status === 7 ? true : false));
  if (isEmpty(filtredExpertStatus.filter((el: any) => el === true))) {
    return false;
  } else {
    return true;
  }
};

export const isRealisedMission = (mission: any) => {
  const filtredExpertStatus = get(
    mission,
    'assignedExperts',
    [],
  ).map((element: any) => (element.status === 5 ? true : false));
  if (isEmpty(filtredExpertStatus.filter((el: any) => el === true))) {
    return false;
  } else {
    return true;
  }
};
export const renderChipLabel = (status: string) => {
  switch (status) {
    case MISSION_STATUS.PENDING:
      return 'En cours';
    case MISSION_STATUS.TRAITED:
      return 'Traitée';
    case MISSION_STATUS.REJECTED:
    case MISSION_STATUS.REJECTED_BY_EXPERT:
      return 'Rejetée';
    default:
      return 'En cours';
  }
};
export const renderColor = (status: string) => {
  switch (status) {
    case MISSION_STATUS.PENDING:
      return COLORS.YELLOW;
    case MISSION_STATUS.TRAITED:
      return COLORS.GREEN;
    case MISSION_STATUS.REJECTED:
    case MISSION_STATUS.REJECTED_BY_EXPERT:
      return COLORS.RED;
    default:
      return COLORS.YELLOW;
  }
};
export const extractRejectExpertStatusTable = (mission: any) => {
  const filtredExpertStatus = get(
    mission,
    'assignedExpert',
    [],
  ).map((element: any) =>
    element.status === 'REJECTED_BY_EXPERT' ? true : false,
  );
  if (isEmpty(filtredExpertStatus.filter((el: any) => el === true))) {
    return get(mission, 'missionStatus').toLocaleUpperCase();
  } else {
    return 'REJETEE';
  }
};

export const constructOldAssignement = (
  mission: any,
  newAssignement: any,
  missionId: number,
) => {
  const newAssignementCode = newAssignement.map(
    (element: any) => element.expertCode,
  );
  const oldAssignementCode = mission.map((item: any) => item.expertCode);
  const constructNewAssignement = newAssignement.filter(
    (ele: any) => !oldAssignementCode.includes(ele.expertCode),
  );
  const ass = constructNewAssignement.map((it: any) => {
    return {
      expertCode: it.expertCode,
      missionId: missionId,
    };
  });
  const assignement = mission.map((el: any) => {
    if (newAssignementCode.includes(el.expertCode)) {
      return {
        id: el?.id,
        expertCode: el.expertCode,
        missionId: missionId,
      };
    } else {
      return {
        id: el?.id,
        expertCode: el.expertCode,
        missionId: missionId,
        isForDelete: true,
      };
    }
  });

  return [...assignement, ...ass];
};

export const isTransactionMission = (mission: any) => {
  return get(mission, 'nature', '') === MISSION_NATURE.TRANSACTION;
};
